import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { api } from "../lib/api";
import type { Capabilities } from "../types";

const CapabilitiesContext = createContext<Capabilities | null>(null);

export function CapabilitiesProvider({ children }: { children: ReactNode }) {
  const [value, setValue] = useState<Capabilities | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    api.capabilities()
      .then((next) => { if (active) setValue(next); })
      .catch((reason) => { if (active) setError(reason instanceof Error ? reason.message : String(reason)); });
    return () => { active = false; };
  }, []);

  if (error) return <div className="loading-state" role="alert">{error}</div>;
  if (!value) return <div className="loading-state">正在读取门户能力</div>;
  return <CapabilitiesContext.Provider value={value}>{children}</CapabilitiesContext.Provider>;
}

export function useCapabilities(): Capabilities {
  const value = useContext(CapabilitiesContext);
  if (!value) throw new Error("useCapabilities must be used inside CapabilitiesProvider");
  return value;
}
